import React from "react";
import BarcodeReader from "react-barcode-reader";
import {
  Modal,
  Input,
  Form,
  Select,
  Icon,
  DatePicker,
  Tabs,
  Button,
  Tag,
  message,
} from "antd";
import moment from "moment";
import "./styles.css";

import {
  FORMAT_2DECIMALS, GREATER_THAN_ZERO,
  FORMAT_3DECIMALS,
} from "../../../common/types/regularExpresionType";
import {
  NOTA_VENTA,
} from "../../../common/types/tipoComprobanteType";

import Productos from "./FormModal/Productos";
import Footer from "./FormModal/Footer";
import auth from "../../../common/utility/auth";
import global from "../../../common/utility/global";
import dialog from "../../../common/utility/dialog";

import {
  VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
  IMPUESTO_SELECTIVO_CONSUMO_VENTA,
  PORCENTAJE_PERCEPCION,
} from "../../../common/types/parametroType";

const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleScan = this.handleScan.bind(this);
  }

  handleScan(data) {
    this.props.onScanerProduct(
      data,
      this.props.form.setFieldsValue,
      this.props.form.getFieldValue
    );
  }
  handleError(err) {
    alert("error");
    console.error(err);
  }


  handleSearchAutocompleteCliente = async (value) => {
    const result = this.props.formValues.clientes
      .filter((item) => {
        return global
          .formatSearch(`${item.nombre} - ${item.tipoDocumento}`)
          .match(global.formatSearch(value));
      })
      .slice(0, 75);
    this.props.form.setFieldsValue({ clientes: result });
  };

  handleChangeAutocompleteCliente = (a, element) => {
    this.props.form.setFieldsValue(
      {
        documentoCliente: element.props.data.numeroDocumento,
      },
      () => {
        this.props.onChange(
          "idProveedor",
          element.props.data.idEntidad,
          this.props.form
        );
      }
    );
  };

  handleCompleteDecimals = (property, value) => {
    if (value === "" || isNaN(parseFloat(value).toFixed(3)))
      this.props.form.setFieldsValue({ [property]: "0.000" });
    else
      this.props.form.setFieldsValue({
        [property]: parseFloat(value).toFixed(3),
      });
  };

  handleCalculateDetail = (row, property, value, numberDecimals, index) => {
    var newValue = this.fetchNewValue(value, numberDecimals);
    var params = auth.user().parametros;

    /********* Datos de parametro ******/
    var porcentajeIGV = 18;
    var porcentajeISC = parseFloat(
      params.filter(
        (m) => m.abreviatura === IMPUESTO_SELECTIVO_CONSUMO_VENTA
      )[0].valor
    );
    var flagPrecioIncluyeIGV =
      params.filter(
        (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
      )[0].valor === "1"
        ? true
        : false;

    /*********** Datos por fila ********/
    var flagChangeTotal = false;
    var flagAfecto =
      property === "arrFlagAfecto"
        ? value
        : this.props.form.getFieldValue(`arrFlagAfecto[${row.identifier}]`);
    var flagGratuito =
      property === "arrFlagGratuito"
        ? value
        : this.props.form.getFieldValue(`arrFlagGratuito[${row.identifier}]`);
    var flagISC =
      property === "arrFlagISC"
        ? value
        : this.props.form.getFieldValue(`arrFlagISC[${row.identifier}]`);
    var precioUnitario = this.fetchFieldValue(
      row.identifier,
      "arrPrecioUnitario"
    );
    var cantidad = this.fetchFieldValue(row.identifier, "arrCantidad");
    var porcentajeDescuento = this.fetchFieldValue(
      row.identifier,
      "arrPorcentajeDescuento"
    );
    var importeDescuento = this.fetchFieldValue(
      row.identifier,
      "arrImporteDescuento"
    );
    var total = this.fetchFieldValue(row.identifier, "arrTotal");

    if (porcentajeDescuento > 100) {
      message.warning("El porcentaje de descuento no puedo ser mayor a 100%");
      return;
    }

    /*********** VALIDACION CASOS EXONERADOS INAFECTOS ********/

    if (!flagAfecto) {
      flagPrecioIncluyeIGV = 0;
    }


    /*********** Datos por fila (bloquear checks) ********/
    if (flagGratuito) {
      flagAfecto = false;
      flagISC = false;
    }
    /*********** Calculo precios unitarios ********/
    var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;
    var precioUnitarioSinIGV = flagPrecioIncluyeIGV
      ? precioUnitario / divisorCalculoSubTotal
      : precioUnitario;

    /*********** Calculo por ISC ********/
    var importeISC = flagISC ? precioUnitarioSinIGV * (porcentajeISC / 100) : 0;
    var precioUnitarioISC = flagISC ? precioUnitarioSinIGV + importeISC : 0;
    var totalDetalle = flagISC
      ? cantidad * precioUnitarioISC
      : cantidad * precioUnitarioSinIGV;

    /*********** Calculo totales ********/
    var subTotal = totalDetalle;
    var igv = parseFloat(
      (flagAfecto ? subTotal * (porcentajeIGV / 100) : 0).toFixed(2)
    );
    total = parseFloat((subTotal + igv).toFixed(2));

    if (property === "arrTotal" && parseFloat(newValue) !== total) {
      flagISC = false;
      importeISC = 0;
      precioUnitarioISC = 0;
      flagChangeTotal = true;

      /*********** Calculo totales ********/
      total = parseFloat(value);
      porcentajeDescuento = 0;
      importeDescuento = 0;
      subTotal = parseFloat(
        (flagAfecto ? total / (1 + porcentajeIGV / 100) : total).toFixed(2)
      );

      /*********** Calculo por ISC ********/
      totalDetalle = flagISC ? cantidad * precioUnitarioISC : subTotal;

      /*********** Calculo Cantidad ********/
      cantidad = parseFloat((subTotal / precioUnitarioSinIGV).toFixed(2));
      if (cantidad === 0) cantidad = 1;

      /*********** Calculo IGV ********/
      igv = flagAfecto ? subTotal * (porcentajeIGV / 100) : 0;
    }

    /*********** Calculo descuentos ********/
    if (importeDescuento > 0 || porcentajeDescuento > 0) {
      var calculoimporteDescuento = parseFloat(
        (total * (porcentajeDescuento / 100)).toFixed(2)
      );

      if (
        importeDescuento !== calculoimporteDescuento &&
        property === "arrImporteDescuento"
      )
        porcentajeDescuento = 0;
      else importeDescuento = calculoimporteDescuento;

      total = total - importeDescuento;

      if (flagAfecto) {
        subTotal = parseFloat((total / divisorCalculoSubTotal).toFixed(2));
        igv = total - subTotal;
        totalDetalle = subTotal;
      } else {
        subTotal = total;
        igv = 0;
        totalDetalle = subTotal;
      }
    }

    /*********** Calculo gratuito ********/
    if (flagGratuito) {
      porcentajeDescuento = 0;
      importeDescuento = 0;
      igv = 0;
      subTotal = 0;
      total = 0;
    }

    /*********** Actualizar Detalle de Productos ********/
    var detalleProductos = this.props.form.getFieldValue("detalleProductos");
    var detalleProductosFilter = detalleProductos.filter((m) => {
      return m.identifier !== row.identifier;
    });

    var dataNueva = {
      identifier: row.identifier,
      numeroLote: this.props.form.getFieldValue(`arrNumeroLote[${row.identifier}]`),
      nombre: this.props.form.getFieldValue(`arrNombre[${row.identifier}]`),
      idProducto: row.idProducto,
      idTipoProducto: row.idTipoProducto,
      precioPromedio: row.precioPromedio,
      porcentajeMargenComercial: row.porcentajeMargenComercial,
      cantidad,
      precioUnitarioSinIGV,
      precioUnitario,
      porcentajeDescuento,
      importeDescuento,
      total,
      flagAfecto,
      flagISC,
      flagOtrosImpuesto: false, // OMITIDO POR EL MOMENTO
      flagGratuito,
      flagChangeTotal,
      subTotal,
    };
    detalleProductosFilter.splice(index, 0, dataNueva);

    /*********** Re-Calcular Suma SubTotal ********/
    var sumaTotalAfecto = this.fetchSumaTotalAfecto(
      row.identifier,
      flagAfecto,
      flagGratuito,
      total
    );
    var sumaTotalInafecto = this.fetchSumaTotalInafecto(
      row.identifier,
      flagAfecto,
      flagGratuito,
      total
    );

    /*********** Calculo suma detalle ********/
    var sumaImporteDescuento = this.fetchFieldValueSum(
      row.identifier,
      "arrImporteDescuento",
      importeDescuento
    );
    var sumaIsc = this.fetchFieldValueSum(
      row.identifier,
      "arrIsc",
      cantidad === 0 ? 0 : importeISC
    );
    var sumaTotal = this.fetchFieldValueSum(row.identifier, "arrTotal", total);
    var sumaSubTotal = parseFloat(
      (sumaTotalAfecto / divisorCalculoSubTotal + sumaTotalInafecto).toFixed(2)
    );
    var sumaIgv = sumaTotal - sumaSubTotal;
    var sumaTotalDetalle = sumaSubTotal;

    /*********** Calculo de Totales 2 ********/
    var flagPercepcion = this.props.form.getFieldValue("flagPercepcion");
    var flagDetraccion = this.props.form.getFieldValue("flagDetraccion");

    var porcentajePercepcion = parseFloat(
      auth
        .user()
        .parametros.filter((m) => m.abreviatura === PORCENTAJE_PERCEPCION)[0]
        .valor
    );
    var importePercepcion = sumaTotal * (porcentajePercepcion / 100);
    var totalPercepcion = sumaTotal + importePercepcion;

    var porcentajeDetraccion = this.props.form.getFieldValue(
      "porcentajeDetraccion"
    );
    var importeDetraccion = sumaTotal * (porcentajeDetraccion / 100);
    var totalDetraccion = sumaTotal - importeDetraccion;

    this.props.form.setFieldsValue({
      sumaImporteDescuento: sumaImporteDescuento,
      sumaIsc: sumaIsc,
      sumaTotal: sumaTotal,
      sumaSubTotal: sumaSubTotal,
      sumaIgv: sumaIgv,
      sumaTotalDetalle: sumaTotalDetalle,
      detalleProductos: detalleProductosFilter,
      [`arrFlagAfecto[${row.identifier}]`]: flagAfecto,
      [`arrFlagGratuito[${row.identifier}]`]: flagGratuito,
      [`arrFlagISC[${row.identifier}]`]: flagISC,
      [`arrIsc[${row.identifier}]`]: cantidad === 0 ? 0 : importeISC,
      [`arrPrecioUnitario[${row.identifier}]`]: precioUnitario.toFixed(5),
      [`arrCantidad[${row.identifier}]`]: cantidad.toFixed(3),
      [`arrTotalDetalle[${row.identifier}]`]: totalDetalle.toFixed(2),
      [`arrPorcentajeDescuento[${row.identifier}]`]:
        porcentajeDescuento.toFixed(2),
      [`arrImporteDescuento[${row.identifier}]`]: importeDescuento.toFixed(2),
      [`arrSubTotal[${row.identifier}]`]: subTotal.toFixed(2),
      [`arrIgv[${row.identifier}]`]: igv.toFixed(2),
      [`arrTotal[${row.identifier}]`]: total.toFixed(2),
      porcentajePercepcion: flagPercepcion ? porcentajePercepcion : 0,
      importePercepcion: flagPercepcion ? importePercepcion : 0,
      totalPercepcion: flagPercepcion ? totalPercepcion : 0,
      porcentajeDetraccion: flagDetraccion ? porcentajeDetraccion : 0,
      importeDetraccion: flagDetraccion ? importeDetraccion : 0,
      totalDetraccion: flagDetraccion ? totalDetraccion : 0,
    });

  };

  handleRemoverProducto = (row) => {

    this.props.form.setFieldsValue({
      sumaImporteDescuento: 0,
      sumaIsc: 0,
      sumaTotal: 0,
      sumaSubTotal: 0,
      sumaIgv: 0,
      sumaTotalDetalle: 0,
      detalleProductos: [],
      porcentajePercepcion: 0,
      importePercepcion: 0,
      totalPercepcion: 0,
      porcentajeDetraccion: 0,
      importeDetraccion: 0,
      totalDetraccion: 0,
    });

    this.props.onRemoverProducto(row, this.props.form);

  };

  fetchNewValue = (value, numberDecimals) => {
    if (numberDecimals === 2)
      return value === "" || isNaN(parseFloat(value).toFixed(2))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 3)
      return value === "" || isNaN(parseFloat(value).toFixed(3))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 5)
      return value === "" || isNaN(parseFloat(value).toFixed(5))
        ? 0
        : parseFloat(value);

    return 0;
  };

  fetchFieldValue = (identifier, property) => {
    var result = parseFloat(
      this.props.form.getFieldValue(`${property}[${identifier}]`)
    );
    return result;
  };

  fetchFieldValueSum = (identifier, property, paramValue) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue(property));

    for (var [key, value] of Object.entries(obj)) {
      suma = suma + (key === identifier ? paramValue : parseFloat(value));
    }

    return suma;
  };

  fetchSumaTotalAfecto = (
    identifier,
    paramFlagAfecto,
    paramFlagGratuito,
    total
  ) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue("arrTotal"));
    for (var [key, value] of Object.entries(obj)) {
      var flagAfecto =
        identifier === key
          ? paramFlagAfecto
          : this.props.form.getFieldValue("arrFlagAfecto")[key];
      var flagGratuito =
        identifier === key
          ? paramFlagGratuito
          : this.props.form.getFieldValue("arrFlagGratuito")[key];
      if (flagAfecto && !flagGratuito) {
        suma += identifier === key ? total : parseFloat(value);
      }
    }
    return suma;
  };

  fetchSumaTotalInafecto = (
    identifier,
    paramFlagAfecto,
    paramFlagGratuito,
    total
  ) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue("arrTotal"));
    for (var [key, value] of Object.entries(obj)) {
      var flagAfecto =
        identifier === key
          ? paramFlagAfecto
          : this.props.form.getFieldValue("arrFlagAfecto")[key];
      var flagGratuito =
        identifier === key
          ? paramFlagGratuito
          : this.props.form.getFieldValue("arrFlagGratuito")[key];
      if (!flagAfecto && !flagGratuito) {
        suma += identifier === key ? total : parseFloat(value);
      }
    }
    return suma;
  };

  handleChangeTotals = (property, value) => {
    if (property === "flagPercepcion" && value) {
      var porcentajePercepcion = parseFloat(
        auth
          .user()
          .parametros.filter((m) => m.abreviatura === PORCENTAJE_PERCEPCION)[0]
          .valor
      );
      var importePercepcion =
        this.fetchFieldValueSum("", "arrTotal", 0) *
        (porcentajePercepcion / 100);
      var totalPercepcion =
        this.fetchFieldValueSum("", "arrTotal", 0) + importePercepcion;

      this.props.form.setFieldsValue({
        porcentajePercepcion,
        importePercepcion,
        totalPercepcion,
        flagDetraccion: false,
        porcentajeDetraccion: 0,
        importeDetraccion: 0,
        totalDetraccion: 0,
        idDetraccion: undefined,
      });
    }

    if (property === "flagDetraccion" && value) {
      this.props.form.setFieldsValue(
        {
          flagPercepcion: false,
        },
        () => {
          this.props.form.validateFields(["idDetraccion"], { force: true });
        }
      );
    }

    if (property === "idDetraccion") {
      var importeDetraccion =
        this.fetchFieldValueSum("", "arrTotal", 0) * (value / 100);
      var totalDetraccion =
        this.fetchFieldValueSum("", "arrTotal", 0) - importeDetraccion;

      this.props.form.setFieldsValue({
        flagPercepcion: false,
        porcentajePercepcion: 0,
        importePercepcion: 0,
        totalPercepcion: 0,
        porcentajeDetraccion: value,
        importeDetraccion,
        totalDetraccion,
      });
    }
  };

  fetchReferencias = (values) => {

    var result = [];

    var flagReferencia = this.props.form.getFieldValue("flagReferencia");
    if (!flagReferencia) {
      this.props.formValues.listaComprobanteReferencia.forEach((item) => {
        result.push({
          idTipoComprobante: item.idTipoComprobante,
          flagInterno: item.flagInterno,
          idReferenciaOrigen: item.idReferenciaOrigen,
          idReferencia: item.idReferencia,
          serie: item.serie,
          documento: item.documento,
        });
      });
      return result;
    }

    if (
      values.arrTipoComprobante === undefined ||
      values.arrSerie === undefined ||
      values.arrDocumento === undefined
    )
      return result;

    var keys = [];
    var obj = Object.assign({}, values.arrTipoComprobante);

    for (var [key, value] of Object.entries(obj)) {
      keys.push(key);
    }

    keys.forEach((key) => {
      result.push({
        idTipoComprobante: values.arrTipoComprobante[key].key,
        serie: values.arrSerie[key],
        documento: values.arrDocumento[key],
        idReferencia: values.arrIdReferencia[key],
        idReferenciaOrigen: values.arrIdReferenciaOrigen[key],
        flagInterno: values.arrFlagInterno[key],
      });
    });

    return result;
  };

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  handleValidateStock = (products, stockProducts) => {

    var elements = [];
    const productGroup = global.groupBy(products, (item) => [
      item.idProducto,
      item.numeroLote,
    ]);

    productGroup.forEach((item) => {
      /**** BUSCAR STOCK POR PRODUCTO Y LOTE ***/
      var stock = stockProducts.filter(
        (m) =>
          m.idProducto === item[0].idProducto &&
          m.numeroLote === item[0].numeroLote
      )[0].stock;

      /**** FILTRAR PRODUCTOS POR ID Y LOTE ***/
      var filteredProducts = products.filter(
        (m) =>
          m.idProducto === item[0].idProducto &&
          m.numeroLote === item[0].numeroLote
      );

      /**** SUMAR CANTIDAD DE PRODUCTOS POR ID Y LOTE ***/
      var total = filteredProducts.reduce(
        (a, b) => a + (b["cantidad"] || 0),
        0
      );

      /**** OBTENER NOMBRE DE PRODUCTOS AFECTADOS POR STOCK ***/
      var productNames = Array.from(
        new Set(filteredProducts.map((m) => m.nombre))
      );

      if (total > stock) {
        elements.push(
          <li>
            Stock no disponible para los productos:{" "}
            <b>{productNames.join(", ")}</b>
          </li>
        );
      }
    });

    return elements;
  };

  handleValidatDetalleAfecto = (products) => {
    var elements1 = [];
    var elements2 = [];
    products.forEach((item) => {
      if (item.flagAfecto) {
        elements1.push(item);
      } else {
        if (item.flagGratuito || item.flagISC) {
          elements1.push(item);
        } else {
          elements2.push(item);
        }
      }
    });

    if (
      elements1.length === products.length ||
      elements2.length === products.length
    )
      return true;
    else return false;
  };

  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log(values);

      if (!err) {

        const data = {
          id: values.id,
          idTipoComprobante: values.idTipoComprobante,
          idProveedor: values.idProveedor === undefined ? 0 : values.idProveedor.key,
          idEstablecimiento: values.idEstablecimiento.key,
          idMoneda: values.idMoneda.key,
          tasa: parseFloat(values.tasa),

          idEstablecimientoProveedor:
            values.idEstablecimientoCliente === undefined
              ? 0
              : values.idEstablecimientoCliente.key,

          idProyecto: values.idProyecto === undefined ? 0 : values.idProyecto.key,
          idUsuarioRegistro: values.idUsuarioRegistro,
          serie: values.serie.toUpperCase(),
          documento: "", //values.documento,
          fechaStr: values.fechaStr.format("DD/MM/YYYY"),
          tipoCambio: parseFloat(values.tipoCambio),
          observacion: values.observacion,
          totalRetencion: values.sumaSubTotal,
          total: values.sumaTotal,
          listaComprobanteDetalle: this.props.formValues.listaComprobanteDetalle,
        };

        if (data.listaComprobanteDetalle.length === 0) {
          dialog.warning("Por favor agregue por lo menos 1 detalle.");
          return;
        }
        this.props.onSave(data, this.props.form);
      }
    });
  };

  //#region  [MEDIO DE PAGO]

  fetchMetodoPago = (values) => {
    var result = [];

    var flagMetodoPago = this.props.form.getFieldValue("flagMetodoPago");
    if (!flagMetodoPago) {
      this.props.formValues.listaComprobanteMetodoPago.forEach((item) => {
        result.push({
          fechaPagoStr: item.fechaPago,
          idMetodoPago: item.idMetodoPago,
          idCuenta: item.idCuenta,
          referencia: item.referencia,
          montoPago: item.montoPago,
        });
      });
      return result;
    }

    if (
      values.arrFechaPago === undefined ||
      values.arrMontoPago === undefined
    )
      return result;

    var keys = [];
    var obj = Object.assign({}, values.arrFechaPago);

    for (var [key] of Object.entries(obj)) {
      keys.push(key);
    }
    keys.forEach((key) => {
      result.push({
        fechaPagoStr:
          values.arrFechaPago[key].format("DD/MM/YYYY"),
        idMetodoPago: values.arrIdTipoMetodoPago[key].key,
        idCuenta: values.arrIdCuenta[key] === undefined ? 0 : values.arrIdCuenta[key].key,
        referencia: values.arrReferenciaPago[key],
        montoPago: parseFloat(values.arrMontoPago[key]),
      });
    });


    return result;
  };

  //#endregion  [END MEDIO DE PAGO]


  fetchParameters = () => {
    var parameters = {};
    this.props.formValue.parameters.forEach((item) => {
      parameters[item.key] = item.value;
    });
    return parameters;
  };


  render() {
    const { getFieldDecorator, setFieldsValue, getFieldValue } =
      this.props.form;

    getFieldDecorator("id", { initialValue: this.props.formValues.id });
    getFieldDecorator("clientes", {
      initialValue: this.props.formValues.clientes.filter((m) => {
        return m.id === this.props.formValues.idProveedor;
      }),
    });
    getFieldDecorator("idTipoComprobante", {
      initialValue: this.props.formValues.idTipoComprobante,
    });


    getFieldDecorator("sumaSubTotal", {
      initialValue: this.props.formValues.sumaSubTotal,
    });

    getFieldDecorator("sumaTotal", {
      initialValue: this.props.formValues.sumaTotal,
    });
    getFieldDecorator("detalleProductos", {
      initialValue: this.props.formValues.listaComprobanteDetalle,
    });


    var title = "Retención ";

    return (
      <Modal
        title={
          this.props.formValues.id === 0
            ? `Registrar ${title}`
            : `Modificar ${title}`
        }
        visible={this.props.visible}
        cancelText={"Cancelar"}
        okText={"Guardar"}
        onCancel={(properties) => {
          if (
            !properties.target.className.toString().match("ant-modal-wrap") ||
            properties.type === "keydown"
          )
            this.handleCancel();
        }}
        onOk={this.handleOk}
        style={{ top: 30 }}
        width="1100px"
      >
        <BarcodeReader onError={this.handleError} onScan={this.handleScan} />

        <Form>
          <div className="row">
            <div className="col-md-3 form-group">
              <Form.Item label="Fecha Pago / Tipo de Cambio">
                <InputGroup compact>
                  <Form.Item style={{ width: "65%" }}>
                    {getFieldDecorator("fechaStr", {
                      initialValue: moment(
                        this.props.formValues.fechaStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                        onChange={(moment, value) =>
                          this.props.onChange(
                            "fechaStr",
                            value,
                            this.props.form
                          )
                        }
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "35%" }}>
                    {getFieldDecorator("tipoCambio", {
                      initialValue: parseFloat(
                        this.props.formValues.tipoCambio
                      ).toFixed(3),
                      rules: [
                        {
                          required: true,
                          pattern: new RegExp(FORMAT_3DECIMALS),
                          message: "Formato decimal incorrecto (0.000)",
                        },
                      ],
                    })(
                      <Input
                        className="text-right second-input"
                        placeholder="Ingresar Tipo de Cambio"
                        autoComplete="off"
                        onBlur={(e) =>
                          this.handleCompleteDecimals(
                            "tipoCambio",
                            e.target.value
                          )
                        }
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Serie / Documento">
                <InputGroup compact>
                  <Form.Item style={{ width: "40%" }}>
                    {getFieldDecorator("serie", {
                      initialValue: this.props.formValues.serie,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                        },
                      ],
                    })(
                      <Input
                        placeholder="Serie"
                        autoComplete="off"
                        className="first-input"
                        style={{ textTransform: "uppercase" }}
                        disabled
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "60%" }}>
                    {getFieldDecorator("documento", {
                      initialValue: this.props.formValues.documento,
                    })(
                      <Input
                        placeholder="Documento"
                        autoComplete="off"
                        className="second-input"
                        maxLength={8}
                        disabled
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Establecimiento">
                {getFieldDecorator("idEstablecimiento", {
                  initialValue: this.props.formValues.idEstablecimiento
                    ? { key: this.props.formValues.idEstablecimiento }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Establecimiento"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.establecimientos.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Tasa %">
                {getFieldDecorator('tasa', {
                  initialValue: parseFloat(this.props.formValues.tasa).toFixed(2),
                  rules: [{
                    pattern: new RegExp(FORMAT_2DECIMALS),
                    message: "Formato decimal incorrecto (0.00)"
                  },
                  {
                    required: true,
                    pattern: new RegExp(GREATER_THAN_ZERO),
                    message: "Ingrese un valor mayor a 0.00"
                  }
                  ]
                })(
                  <Input
                    addonAfter={<Icon type="percentage" />}
                    className="text-right"
                    placeholder="Ingresar tasa"
                    autoComplete="off"
                    maxLength={100}
                    readOnly
                    onKeyPress={global.onKeyPressDecimals}
                    onBlur={(e) => {
                      this.props.form.setFieldsValue({
                        stockMin: global.onBlurDecimals(e, 2)
                      });
                    }}
                  />
                )}
              </Form.Item>
            </div>

          </div>

          <div className="row">
            <div className="col-md-3 form-group">
              <Form.Item label="Nro Documento">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("documentoCliente", {
                      initialValue: this.props.formValues.documentoCliente,
                    })(
                      <Search
                        placeholder="Documento"
                        className="first-input"
                        autoComplete="off"
                        loading={this.props.formValues.clienteLoading}
                        onSearch={(value) =>
                          this.props.onBuscarCliente(value, this.props.form)
                        }
                        maxLength={20}
                      />
                    )}
                  </Form.Item>

                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-9 form-group">
              <Form.Item label="Proveedor">
                <InputGroup compact>

                  <Form.Item style={{ width: "100%" }}>
                    <InputGroup compact style={{ marginBottom: "1px" }}>
                      {getFieldDecorator("idProveedor", {
                        initialValue: this.props.formValues.idProveedor
                          ? { key: this.props.formValues.idProveedor }
                          : undefined,
                      })(
                        <Select
                          showSearch
                          labelInValue
                          style={{
                            width: `calc(100% - 40px)`,
                            borderTopLeftRadius: "0px",
                          }}
                          placeholder={"Búsqueda de Proveedor"}
                          optionFilterProp="children"
                          showArrow={false}
                          onSearch={this.handleSearchAutocompleteCliente}
                          onChange={this.handleChangeAutocompleteCliente}
                        >
                          {getFieldValue("clientes").map((item) => (
                            <Option key={item.id} value={item.id} data={item}>
                              <Tag>{item.tipoDocumentoNombre}</Tag>
                              {`${item.nombre}`}
                            </Option>
                          ))}
                        </Select>
                      )}
                      <Button
                        className="btn-autocomplete"
                        style={{ width: "40px", fontSize: "14px" }}
                        icon={
                          this.props.form.getFieldValue("idProveedor")
                            ? "close"
                            : "search"
                        }
                        onClick={() => {
                          this.props.form.setFieldsValue(
                            {
                              idProveedor: undefined,
                              documentoCliente: "",
                              idEstablecimientoCliente: undefined,
                            },
                            () => {
                              this.props.onChange("direcciones-clear");
                            }
                          );
                        }}
                      />
                    </InputGroup>
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>



            <div className="col-md-9 form-group">
              <Form.Item label="Dirección">
                {getFieldDecorator("idEstablecimientoCliente", {
                  initialValue: this.props.formValues.idEstablecimientoCliente
                    ? { key: this.props.formValues.idEstablecimientoCliente }
                    : undefined,
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Direccion"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.direcciones.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre + " - " + item.direccion}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Proyecto">
                {getFieldDecorator("idProyecto", {
                  initialValue: this.props.formValues.idProyecto
                    ? { key: this.props.formValues.idProyecto }
                    : undefined,
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Proyecto"}
                    optionFilterProp="children"
                    disabled={this.props.formValues.isReadOnly}
                  >
                    {this.props.formValues.proyectos.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col-md-9 form-group">
              <Form.Item label="Observación">
                {getFieldDecorator("observacion", {
                  initialValue: this.props.formValues.observacion,
                })(
                  <Input
                    placeholder="Ingresar Observación"
                    autoComplete="off"
                  />
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Moneda">
                {getFieldDecorator('idMoneda', {
                  initialValue: this.props.formValues.idMoneda ?
                    { key: this.props.formValues.idMoneda } : undefined,
                  rules: [{
                    required: true,
                    message: 'Campo obligatorio.',
                  }]
                })(
                  <Select showSearch labelInValue
                    placeholder={"Seleccione Moneda"}
                    optionFilterProp="children"
                    disabled
                    onChange={(option) => {
                      this.props.form.setFieldsValue(
                        this.props.onChange("idMoneda", option.key)
                      );
                    }}
                  >
                    {this.props.formValues.monedas.map(item => (
                      <Option key={item.id} value={item.id}>{item.nombre}</Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

          </div>

          <div className="row">

            <div className="col-md-12 form-group">
              <Tabs
                activeKey={this.props.formValues.activeKey}
                onChange={(key) => this.props.onChangeTab(key, setFieldsValue)}
                tabBarExtraContent={
                  <div className="custom-options">


                    <Button
                      icon="plus"
                      type="success"
                      onClick={() =>
                        this.props.onImportarCompra(
                          this.props.form.setFieldsValue,
                          this.props.form.getFieldValue
                        )
                      }
                    >
                      Importar Documento
                    </Button>

                    {auth.user().planCode == "PLA001" ?
                      <Button
                        icon="plus"
                        type="primary"
                        onClick={() =>
                          this.props.onAgregarDetalle(
                            this.props.form.setFieldsValue,
                            this.props.form.getFieldValue
                          )
                        }
                      >
                        Agregar Documento
                      </Button>
                      : null
                    }

                  </div>
                }
              >
                <TabPane
                  tab={
                    <span>
                      <Icon type="ordered-list" />
                      Detalle de Comprobantes
                    </span>
                  }
                  key="1"
                >
                  <Productos
                    dataSource={this.props.formValues.listaComprobanteDetalle}
                    precioUnitarioDisabled={
                      this.props.formValues.precioUnitarioDetailDisabled
                    }
                    totalDisabled={this.props.formValues.totalDetailDisabled}
                    onRemove={this.handleRemoverProducto}
                    onEditarNombreProducto={this.props.onEditarNombreProducto}
                    onCalculateDetail={this.handleCalculateDetail}
                    onGetFieldDecorator={getFieldDecorator}
                    onSetFieldsValue={setFieldsValue}
                    onGetFieldValue={getFieldValue}
                  />
                </TabPane>
              </Tabs>
            </div>
          </div>
          <Footer
            formValues={this.props.formValues}
            onChangeTotals={this.handleChangeTotals}
            onGetFieldDecorator={getFieldDecorator}
            onGetFieldValue={getFieldValue}
          />
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(FormModal);
